import { LogoIcon } from "@/components/icons/logo-icon";
import {
  IonButton,
  IonHeader,
  IonIcon,
  IonToolbar,
  useIonRouter,
} from "@ionic/react";
import { arrowBackOutline } from "ionicons/icons";
import { memo } from "react";

interface HeaderToolbarProps {
  showBackButton?: boolean;
  bgColor?: string;
}

export const HeaderToolbar = memo(function HeaderToolbar({
  showBackButton = false,
  bgColor,
}: HeaderToolbarProps) {
  const router = useIonRouter();

  return (
    <IonHeader className="ion-no-border">
      <IonToolbar color={bgColor} className="safe-area-top">
        <div className="w-full max-w-[420px] mx-auto flex items-center justify-start">
          {showBackButton && (
            <IonButton
              size="small"
              fill="clear"
              color="dark"
              shape="round"
              className="flex items-center justify-center"
              onClick={() => router.goBack()}
            >
              <IonIcon icon={arrowBackOutline} className="mr-2" />
            </IonButton>
          )}
          <LogoIcon className="fixed left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 max-w-[120px]" />
        </div>
      </IonToolbar>
    </IonHeader>
  );
});
